import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initSnapfail } from '@snapfail/browser'
import './index.css'
import App from './App.tsx'

initSnapfail({
  projectKey: import.meta.env.VITE_SNAPFAIL_PROJECT_KEY ?? "",
  endpoint: "https://app.snapfail.com",
  environment: import.meta.env.PROD ? "prod" : "dev",
  buildId: import.meta.env.VITE_SNAPFAIL_BUILD_ID ?? "",
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
